import { copy } from 'global';

const contactText = [
  {
    heading: 'Contact',
    paragraph:
`
${copy.contactText} (Here's ((my LinkedIn profile|||www.linkedin.com/in/justin-poser-a328b3167/))).
`
  }
];

export default contactText;